const
    createNamed = (storage, name, defaultExpiration) => {
        const
            {
                get,
                set,
                update,
                clear,
                cleared
            } = storage;

        return {
            name,
            get: () => get(name),
            set: (
                (values, expiration = defaultExpiration) => (
                    set(name, values, expiration))),
            update: (
                (values, expiration = defaultExpiration) => (
                    update(name, values, expiration))),
            clear: () => clear(name),
            cleared: cleared.filter(key => name === key)
        };
    };

export {
    createNamed
};
